import { render } from "./SocialMediaLinksComp.vue?vue&type=template&id=40610cf2&scoped=true"
import script from "./SocialMediaLinksComp.vue?vue&type=script&lang=js"
export * from "./SocialMediaLinksComp.vue?vue&type=script&lang=js"

import "./SocialMediaLinksComp.vue?vue&type=style&index=0&id=40610cf2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40610cf2"]])

export default __exports__